import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSpinner } from 'ngx-spinner/lib/ngx-spinner.enum';
import { MessageService } from 'primeng/api';
import { email } from 'src/app/models/email';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-valid-afiliacion',
  templateUrl: './valid-afiliacion.component.html',
  styleUrls: ['./valid-afiliacion.component.css']
})
export class ValidAfiliacionComponent implements OnInit {
  public email: email;
  actual = environment.actual;
  modulo = environment.entidad[this.actual].moduloAfil
  logo = environment.entidad[this.actual].urlLogo
  heightLogo = environment.entidad[this.actual].heightLogo
  image = `url(${environment.entidad[this.actual].backgroundLogin})`;
  public validaCodigo = false

  constructor(
    private servicio: UserService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private messageService: MessageService) {
    this.email = new email('');
  }

  ngOnInit(): void {
    localStorage.clear()
    sessionStorage.clear()
    this.Config();
  }

  onSubmitEmail(formCorreo) {
    console.log('Enviando...');
    this.spinner.show()
    if (this.email.correo != null && this.email.correo != '') {
      this.servicio.httpPost('correoAfiliacion', this.email).subscribe(
        response => {
          if (response['status'] == 'success') {
            this.messageService.add({ severity: 'success', detail: response['message'] });
            /*Swal.fire({
              icon: 'success',
              text: response['message']
            })*/
            this.validaCodigo = true;
            this.spinner.hide()
          } else {
            this.messageService.add({ severity: 'error', detail: response['message'] });
            /*Swal.fire({
              icon: 'error',
              text: response['message']
            })*/
            this.validaCodigo = false;
            this.spinner.hide()
          }
        },
        error => {
          this.spinner.hide()
        }
      )
    } else {
      this.messageService.add({ severity: 'info', detail: 'Por favor complete los campos' });
      /*Swal.fire({
        icon: 'info',
        text: 'Por favor complete los campos'
      })*/
      this.spinner.hide()
    }
  }

  onSubmitCode(formCorreo) {
    this.spinner.show()
    this.servicio.httpPost('codigoAfiliacion', this.email).subscribe(
      response => {
        if (response.status == 'success') {
          this.spinner.hide()
          this.servicio.SetsessionStorage('token', response.token)
          this.servicio.SetsessionStorage('validoAfiliacion', 'si')
          this.servicio.SetsessionStorage('email', this.email.correo)
          this.servicio.SetsessionStorage('iconos', JSON.stringify([
            {
              "id": 19,
              "parametro": "Salir",
              "valor": "S",
              "url": "salir/2",
              "nombre_menu": "Salir",
              "icono": "salir.png",
              "menu_principal": "N",
              "ventana_nueva": "N",
              "menu_zonap": "S",
              "menu_app": "N",
              "icono_app": null,
              "createdAt": null,
              "updatedAt": null,
              "orden": 13
            }
          ]))
          /*localStorage.setItem('token', response.token)
          localStorage.setItem('validoAfiliacion', 'si')
          localStorage.setItem('email', this.email.correo)*/
          /*localStorage.setItem('iconos', JSON.stringify([
            {
              "id": 19,
              "parametro": "Salir",
              "valor": "S",
              "url": "salir/2",
              "nombre_menu": "Salir",
              "icono": "salir.png",
              "menu_principal": "N",
              "ventana_nueva": "N",
              "menu_zonap": "S",
              "menu_app": "N",
              "icono_app": null,
              "createdAt": null,
              "updatedAt": null,
              "orden": 13
            }
          ]))*/
          console.log(this.servicio.GetsessionStorage('iconos'))
          this.modal()
          //this.router.navigate(['afiliacion-form']);
        } else {
          Swal.fire({
            icon: 'error',
            text: response['message']
          })
          this.spinner.hide()
          localStorage.setItem('validoAfiliacion', 'no')
        }
      }
    )
  }

  Config() {
    this.servicio.httpGet('parametrosConfig').subscribe(
      (response: any) => {
        this.spinner.hide();
        this.servicio.SetsessionStorage('config', JSON.stringify(response.details))
        //localStorage.setItem('config', JSON.stringify(response.details))
      },
      error => {
        this.spinner.hide();
        console.log(error as any);
      }
    )
  }

  modal() {
    /*Swal.fire({
      title: 'Por favor seleccione el tipo de afiliación',
      input: 'select',
      inputOptions: {
        '0': 'Seleccione',
        '1': 'Natural',
        '2': 'Juridica'
      },
      showCancelButton: false,
      confirmButtonText: 'Aceptar',
      showLoaderOnConfirm: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value != 0) {
          localStorage.setItem('tpAfil', result.value.toString())
          this.router.navigate(['afiliacion-form']);
        }else{
          this.modal()
        }
      }
    })*/

    this.servicio.SetsessionStorage('tpAfil', '3')
    //localStorage.setItem('tpAfil', '3')
    this.router.navigate(['afiliacion-form']);
  }

}
